import Header from "components/layout/ListHeader";
import { Code, Utility } from "helpers/CalendarImports";

const Spaces = (count: number): string => {
  return ' '.repeat(count);
};

const Zeros = (count: number): string => {
  return '0'.repeat(count);
};

const Dashes = (count: number): string => {
  return '-'.repeat(count);
};

const LeadingZeros = (input: string | undefined , width: number = 6): string => {
  if(!input) return Spaces(width);
  if (typeof input !== 'string') input = String(input);
  return input.padStart(width, '0');
};

const LeadingSpaces = (input: string | undefined, width: number = 6): string => {
  if(!input) return Spaces(width);
  input = String(input).trim();
  return input.padStart(width, ' ');
};

const EndSpaces = (input: string | undefined, width: number = 6): string => {
  if(!input) return Spaces(width);
  input = String(input).trim();
  return input.padEnd(width, ' ');
};

const downloadFile = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url); // Clean up
  };

const HlinkHeader = (
    SubmitterCode:string,
    FileNo:string
  ):string => {
  //FORMAT"{1:1}{2:3}{3:6}{4:S244}
  let data = '2'; // 1:Record Type ( 1 digits)
  data += SubmitterCode; // 2:Submitter Code ( 3 digits)
  data += LeadingZeros(FileNo, 6); // 3:File Number   ( 6 digits)
  data += Spaces(244); // 4:244Spaces
  data += '\n'; // New line
  return data;
}

const HlinkFooter = (
  SubmitterCode:string,
  FileNo:string, 
  Records: number
):string => {
  //FORMAT"{1:1}{2:3}{3:6}{4:5}{5:8}{6:S231}
  let data = '4'; // 1:Record Type ( 1 digits)
  data += SubmitterCode; // 2:Submitter Code ( 3 digits)
  data += LeadingZeros(FileNo, 6); // 3:File Number ( 6 digits)
  data += LeadingZeros(Records.toString(), 5); // 4:Records Count ( 5 digits)
  data += LeadingZeros(Records.toString(), 8); // 5:Records Count ( 8 digits)
  data += Spaces(231); // 6:231 Spaces
  data += '\n'; // New line
  return data;
}

const HlinkRow = (
  SubmitterCode:string,
  BillingDate:Date | undefined,
  DoctorCode:string | undefined,
  Sequence:number | undefined,
  ActionCode:string | undefined,
  PractitionerId:string | undefined,
  HealthCardNo:string | undefined,
  HSCCode:string | undefined,
  DiagnosticCode:string | undefined,
  Modifier1:string | undefined,
  Modifier2:string | undefined,
  Modifier3:string | undefined,
  FacilityNumber:string | undefined,
  FunctionalCentre:string | undefined,
  BusinessArrangement:string | undefined,
  PayToCode:string | undefined,
  PayToULI:string | undefined,
  BillingNumber:string | undefined,
  Amount:number | undefined,
):string => {
  //SEGMENT TYPE - CIB1
  //{1:1:rowno}{2:3:SubmitterCode}{3:2:Year}{4:2:DoctorCode}{5:7:RecordNo}
  //{6:1:CheckSum}{7:4:TransactionType}{8:4:SegmentType}{9:4:SegmentSequence}{10:1:ActionCode}
  //{11:S6:Spaces(6)}{12:4:RGLR}{13:9:PractitionerId}{14:S4:Spaces(4)}{15:9:AHCNo}
  //{16:S12:Spaces(12)}{17:4+S3:HSCCode}{18:8:Spaces(3)}{19:1:ServiceDate}{20:5:EncounterNumber}
  //{21:13:DiagnosticCode}{22:3:Spaces(13)}{23:6:Calls}{24:6:Modifier1}{25:6:Modifier2}
  //{26:6:Modifier3}{27:4:FacilityNumber}{28:S4:FunctionalCentre}{29:6:Spaces(4)}{30:S4:Zeros(6)}
  //{31:7:Spaces(4)}{32:4:BusinessArrangement}{33:9:PayToCode}{34:S7:PayToULI}{35:9:Spaces(7)}
  // {36:1:PRACID}{37:4:Spaces(1)}{38:14:Spaces(4)}{39:9:BillingSNo}{40:S38:Amount}{41:S38:Spaces(38)}
  const TransactionType = "CIP1"; //Same: In-Province claims
  const SegmentType = "CIB1"; //Same : In-Province Provider Base Claim segment
  const SegmentSequence = "0001"; //ComSamemn: Unique sequence of a segment within a transaction
  const Calls = '001'; //Same: Number of consecutive hospital visit days
  const EncounterNumber= "1"; //Same: Service was performed on the same day
  
  if(!Sequence) Sequence = 0;
  const sequence = LeadingZeros(Sequence.toString(),7);
  //console.log("sequence:",sequence);
  const CheckSum = LuhnChecksum(sequence);

  if(!BillingDate) BillingDate = Utility.Date.getLocalDate();

  //console.log("BillingDate----->", BillingDate)

  const endOftheToday = new Date(`${Utility.Format.Date(Utility.Date.getLocalDate(),"yyyy-MM-dd")} 23:59:00`)
  
  //console.log("endOftheDay----->", BillingDate, endOftheToday, (BillingDate > endOftheToday));

  if(BillingDate > endOftheToday) BillingDate = Utility.Date.getLocalDate();
  
  const threeMonthOld = new Date();
  threeMonthOld.setMonth(threeMonthOld.getMonth() - 3);

  //console.log("threeMonthOld----->", BillingDate, threeMonthOld, (BillingDate < threeMonthOld));
  
  if(BillingDate < threeMonthOld) BillingDate = Utility.Date.getLocalDate();
  
  //2 digits
  const Year = Utility.Format.Date(BillingDate,"yy"); 
  
  //8 digits
  const ServiceDate = Utility.Format.Date(BillingDate,"yyyyMMdd"); 

  //2 digits
  if(!DoctorCode || DoctorCode.length !== 2) {
    DoctorCode = Spaces(2) 
  }
  DoctorCode = DoctorCode.toUpperCase();

  //1 digits
  if(ActionCode == null || ActionCode.length == 0) { 
     ActionCode = Code.Option.ActionAHS.Add;
  }
  ActionCode = ActionCode.toUpperCase();

  //9 digits
  if(!PractitionerId || PractitionerId.length !== 9) {
    PractitionerId = Spaces(9);
  }

  //9 digits
  if(!HealthCardNo || HealthCardNo.length !== 9) {
    HealthCardNo = Spaces(9);
  }

  //4 digits
  if(!HSCCode || HSCCode.length !== 4) {
    HSCCode = Spaces(4);
  }

  //5 digits
  if(DiagnosticCode) {
    DiagnosticCode = EndSpaces(DiagnosticCode,5);
  }
  else DiagnosticCode = Spaces(5)

  
  let PRACID = PractitionerId;

  //6 digits
  Modifier1 = updateModifier(Modifier1);
  Modifier2 = updateModifier(Modifier2);
  Modifier3 = updateModifier(Modifier3);

  if(!(Modifier1.includes("OPHTCO") || Modifier2.includes("OPHTCO") || Modifier3.includes("OPHTCO"))) { PRACID = Spaces(9); }

  //6 digits
  if(!FacilityNumber || FacilityNumber.length !== 6) {
    FacilityNumber = Spaces(6);
  }

  //4 digits
  if(!FunctionalCentre || FunctionalCentre.length !== 4) {
    FunctionalCentre = Spaces(4);
  }

  //7 digits
  if(!BusinessArrangement || BusinessArrangement.length !== 7) {
    BusinessArrangement = Spaces(7);
  }

  //4 digits
  if(!PayToCode || PayToCode.length !== 4) {
    PayToCode = Spaces(4);
  }

  //9 digits
  if(!PayToULI || PayToULI.length !== 9) {
    PayToULI = Spaces(9);
  }

  //14 digits
  BillingNumber = EndSpaces(BillingNumber, 14);

  //9 digits
  if(!Amount) Amount = 0;
  let amount = parseFloat(Amount.toString()).toFixed(2);
  amount = LeadingZeros(amount.replace(".",""),9);
  

  let data = '3'; // 1:Record Type  ( 1 digits)
  data += SubmitterCode; // 2:Submitter Code  ( 3 digits)
  data += Year; // 3:Year  ( 2 digits)
  data += DoctorCode; // 4:Doctor Code  ( 2 digits)
  data += sequence; // 5:Record Number  ( 7 digits)
  data += CheckSum; // 6:Check Sum  ( 1 digits)
  data += TransactionType; // 7:Transaction Type  ( 4 digits)
  data += SegmentType; // 8:Segment Type  ( 4 digits)
  data += SegmentSequence; // 9:Segment Sequence  ( 4 digits)
  data += ActionCode; // 10:Action Code  ( 1 digits)

  data += Spaces(6); // 11:Spaces  ( 6 digits)
  data += 'RGLR'; // 12:Record Type  ( 4 digits)
  data += PractitionerId; // 13:Practitioner ID  ( 9 digits)
  data += Spaces(4); // 14:Skill Code  ( 4 digits)
  data += HealthCardNo; // 15:Personal Health Number  ( 9 digits)
  data += Spaces(12); // 16:Service Recipient Registration  ( 12 digits)
  data += HSCCode+Spaces(3); // 17:Health Service Code  ( 4 digits + 3 digits)
  data += ServiceDate; // 18:Service Start Date YYYYMMDD  ( 8 digits)
  data += EncounterNumber; // 19:Encounter Number  ( 1 digits)
  data += DiagnosticCode; // 20:Diagnostic Code  ( 5 digits)

  data += Spaces(13); // 21:Spaces  ( 13 digits)
  data += Calls; // 22:Calls  ( 3 digits)
  data += Modifier1; // 23:Modifier 1  ( 6 digits)
  data += Modifier2; // 24:Modifier 2  ( 6 digits)
  data += Modifier3; // 25:Modifier 3  ( 6 digits)
  data += FacilityNumber; // 26:Facility Number  ( 6 digits)
  data += FunctionalCentre; // 27:Functional Centre  ( 4 digits)
  data += Spaces(4); // 28:Spaces  ( 4 digits) Location Code left blank
  data += LeadingZeros('0', 6); // 29:Originating Facility ( 6 digits) 
  data += Spaces(4); // 30:Originating Location  ( 4 digits)

  data += BusinessArrangement; // 31:Business Arrangement  ( 7 digits)
  data += PayToCode; // 32:Pay To Code  ( 4 digits)
  data += PayToULI; // 33:Pay To ULI  ( 9 digits)
  data += Spaces(7); // 34:Locum Arrangement ( 7 digits)
  data += PRACID; // 35:Practitioner ID  ( 9 digits)
  data += Spaces(1); // 36:Spaces  ( 1 digits)
  data += Spaces(4); // 37:Spaces  ( 4 digits)
  data += BillingNumber; // 38:Billing Serial Number  ( 14 digits)
  data += amount; // 39:Amount  ( 9 digits)
  data += Spaces(38); // 40:Various Values left blank  ( 38 digits)
  data += '\n'; // New line
  return data;
}

const updateModifier = (modifier: string | undefined ): string => {
  if(modifier && modifier.length){
      modifier = modifier.toUpperCase(); 
      if (modifier.includes('NEWEP')) modifier = "NEWEP ";
  }
  else modifier = Spaces(6);
  return modifier;
}

export function LuhnChecksum(code: string): string {
  code = code + "0";
  const len = code.length;
  const parity = len % 2;
  let sum = 0;

  for (let i = len - 1; i >= 0; i--) {
    let digit = parseInt(code[i], 10);

    if (i % 2 === parity) {
      digit *= 2;
    }

    if (digit > 9) {
      digit -= 9;
    }

    sum += digit;
  }

  const checksum = sum % 10;
  return checksum === 0 ? "0" : (10 - checksum).toString();
}

const getSubmitterCode = (dctrCode: number | undefined): number => {
  switch (dctrCode) {
    case 25: return 11; // Dummy Dr. Navdeep Singh (Nobe) Nijjar
    case 26: return 10; // Dr. Lovedeep Banipal
    case 46: return 10; // Dr. Aman Dhaliwal
    case 29: return 11; // Dr. Aliya Pabani
    case 28: return 11; // Dr. Karen Dieu
    case 18: return 11; // Dr. Navdeep Singh (Nobe) Nijjar
    case 42: return 11; // Dr. Shu Yi Wen
    case 44: return 11; // Dr. Salina Kanji
    case 47: return 11; // Dr. Ashley Chea
    default: return 0;
  }
};

const getSubmitterPrefix = (sbmtCode: number): string => {
  switch (sbmtCode) {
    case 10: return "CAE";
    case 11: return "NOB";
    default: return '';
  }
};

export const ClaimHelper = {
  Header: HlinkHeader,
  Footer: HlinkFooter,
  Row: HlinkRow,
  Spaces: Spaces,
  Dashes: Dashes,
  LeadingZeros: LeadingZeros,
  LeadingSpaces: LeadingSpaces,
  EndSpaces: EndSpaces,
  download: downloadFile,
  SubmitterCode: getSubmitterCode,
  SubmitterPrefix: getSubmitterPrefix,
}